(function () {
	let collapsibleWithImage = () => {
		// Устанавливаем первый элемент как активный при инициализации
		$(".collapsible-with-image_item-wrapper").first().addClass("active");

		$(".collapsible-with-image_item-wrapper").hover(
			function () {
				$(this).addClass("active");
				$(this).siblings(".collapsible-with-image_item-wrapper").removeClass("active");
			},
			function () {
				// Удаляем класс active при уходе курсора с блока
				$(this).removeClass("active");
				// Добавляем active к первому элементу, если курсор не над ним
				$(".collapsible-with-image_item-wrapper").first().addClass("active");
			}
		);
	};

	document.addEventListener("shopify:section:load", function () {
		collapsibleWithImage();
	});

	collapsibleWithImage();
})();
